import { render } from "./AnalisisVentas.vue?vue&type=template&id=7171f922&scoped=true"
import script from "./AnalisisVentas.vue?vue&type=script&lang=js"
export * from "./AnalisisVentas.vue?vue&type=script&lang=js"

import "./AnalisisVentas.vue?vue&type=style&index=0&id=7171f922&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7171f922"]])

export default __exports__